import React from 'react';
import InfoCards from './InfoCards';
import FAQQuestions from './FAQQuestions';

export const FAQ = () => {

    return (
        <div className='w-100 h-100'>
            <FAQQuestions />
            <InfoCards />
        </div>
    );
}
export default FAQ